import React from "react";
import "./css/styles.css";
import ReactDOM from "react-dom/client"; // Import from 'react-dom/client' in React 18
import App from "./App";

// Create a root and render the App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
